import React from "react";
import styled, { createGlobalStyle } from "styled-components";

import Sidebar from "../../components/Navigation/Sidebar/Sidebar";
import Header from "../../components/Layout/Header/Header";
import Footer from "../../components/Layout/Footer/Footer";
import { spacing } from "@mui/system";
import {
  Hidden,
  CssBaseline,
  Paper as MuiPaper,
  Typography,
  Button,
} from "@mui/material";

import { connect } from "react-redux";
import * as actionTypes from "../../redux/constants";

import "./Dashboard.scss";
import { spring_security_logout } from "../../api/shared/signin";

import { Redirect } from "react-router-dom";

const URL_LOGIN = "/";

const drawerWidth = 220;
const collapsedDrawerWidth = 80;

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${(props) => props.theme.body.background};
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #e0e0e7;
`;

const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
  flex: 1;
  background-color: #e0e0e7 !important;
  padding: 0px !important;
  border: none !important;
  box-shadow: none !important;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

class Dashboard extends React.Component {
  state = {
    anchorMenu: null,
    doRedirect: false,
    redirectTarget: null,
  };

  handleDrawerToggle = () => {
    if (this.props.menuCollapsed) {
      this.props.expandMenu();
    } else {
      this.props.collapseMenu();
    }
  };

  redirectToUrl = (url) => {
    this.setState({
      ...this.state,
      doRedirect: true,
      redirectTarget: url,
      anchorMenu: null,
    });
  };

  logout = () => {
    spring_security_logout().then(() => {
      this.props.clearUser();
      setTimeout(() => {
        this.redirectToUrl(URL_LOGIN);
      }, 10);
    });
  };

  render() {
    const { children, routes, width } = this.props;

    if (this.state.doRedirect) {
      this.setState({
        ...this.state,
        doRedirect: false,
      });
      return <Redirect to={this.state.redirectTarget} />;
    }

    let sideBarWidth = drawerWidth;
    if (this.props.menuCollapsed) {
      sideBarWidth = collapsedDrawerWidth;
    }

    return (
      <Root>
        <CssBaseline />
        <GlobalStyle />
        <Drawer
          className={"dashboard-drawer"}
          style={{
            width: sideBarWidth,
          }}
        >
          <Hidden mdUp implementation="js">
            <Sidebar
              routes={routes}
              PaperProps={{ style: { width: collapsedDrawerWidth } }}
              variant="permanent"
              open={false}
            />
          </Hidden>
          <Hidden smDown implementation="css">
            <Sidebar
              routes={routes}
              PaperProps={{ style: { width: sideBarWidth } }}
              open={!this.props.menuCollapsed}
              toggleOpen={this.handleDrawerToggle}
            />
          </Hidden>
        </Drawer>
        <AppContent className={"app-content"}>
          <Header />
          <div className={"dashboard-layout-content"}>
            <MainContent p={10}>{children}</MainContent>
          </div>
          <div className={"bad-screensize-warning"}>
            <Typography component={"label"}>
              This application is not designed for use on mobile devices. Please
              try again with your laptop/desktop or tablet to continue.
            </Typography>
            <Button
              className={"dashboard-logout"}
              color={"primary"}
              variant={"contained"}
              onClick={() => {
                this.logout();
              }}
            >
              Log Out
            </Button>
          </div>
          <Footer />
        </AppContent>
      </Root>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuCollapsed: state.uxStateReducer.get("sideMenuCollapsed"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearUser: () =>
      dispatch({
        type: actionTypes.CLEAR_CURRENT_USER_DATA,
      }),
    collapseMenu: () =>
      dispatch({
        type: actionTypes.SET_SIDE_MENU_COLLAPSED,
      }),
    expandMenu: () =>
      dispatch({
        type: actionTypes.SET_SIDE_MENU_EXPANDED,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
